module.exports = __webpack_public_path__ + "static/media/arrow2.a0fe92ac.svg";